import React, { useEffect, useState } from 'react';
import { ToolbarProps } from 'react-big-calendar';
import { ArrowRight, ArrowLeft } from 'lucide-react';

const CustomToolbar = (props: ToolbarProps) => {
  const { onNavigate, label, view, onView } = props;
  const [selectedView, setSelectedView] = useState(view);
  useEffect(()=>{
    onView('week')
    setSelectedView('week')
  },[])
  // Handle view change
  const handleViewChange = (newView) => {
    setSelectedView(newView);
    onView(newView); 
  };
 

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button
          type="button"
          onClick={() => onNavigate('PREV')}
          style={{ backgroundColor: 'transparent', border: 'none', margin: "5px", color: '#ff176b' }}
        >
          <ArrowLeft />
        </button>
        <button
          type="button"
          onClick={() => onNavigate('NEXT')}
          style={{ backgroundColor: 'transparent', border: 'none', margin: "5px", color: '#ff176b' }}
        >
          <ArrowRight />
        </button>
      </span>
      <span className="rbc-toolbar-label">{label}</span>
      <span className="rbc-btn-group">
        <button
          type="button"
          onClick={() => handleViewChange('day')}
          style={{ backgroundColor: selectedView === 'day' ? '#d3d3d3' : 'transparent' }} // Change color based on selection
        >
          Day
        </button>
        <button
          type="button"
          onClick={() => handleViewChange('week')}
          style={{ backgroundColor: selectedView === 'week' ? '#d3d3d3' : 'transparent' }} // Change color based on selection
        >
          Week
        </button>
        <button
          type="button"
          onClick={() => handleViewChange('month')}
          style={{ backgroundColor: selectedView === 'month' ? '#d3d3d3' : 'transparent' }} // Change color based on selection
        >
          Month
        </button>
      </span>
    </div>
  );
};

export default CustomToolbar;
